import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cn } from "../../../client/cn";

export interface DrawerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: React.ReactNode;
  children: React.ReactNode;
  side?: "left" | "right";
  overlayClassName?: string;
  contentClassName?: string;
}

export interface DrawerDialogCloseProps {
  children: React.ReactNode;
  className?: string;
  ariaLabel?: string;
}

export function DrawerDialog({
  open,
  onOpenChange,
  title,
  children,
  side = "left",
  overlayClassName = "",
  contentClassName = "",
}: DrawerDialogProps) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay
          className={cn(
            "fixed inset-0 z-40 bg-black/30",
            "animate-[drawer-overlay-in_300ms_ease-in-out] motion-reduce:animate-none",
            overlayClassName,
          )}
        />
        <DialogPrimitive.Content
          aria-describedby={undefined}
          className={cn(
            "fixed inset-y-0 z-50 w-80 overflow-y-auto border-neutral-200 bg-white p-4 shadow-xl focus:outline-none dark:border-strokedark dark:bg-boxdark",
            side === "left" ? "left-0 border-r" : "right-0 border-l",
            "animate-[drawer-slide-in_300ms_ease-in-out] motion-reduce:animate-none",
            contentClassName,
          )}
        >
          <DialogPrimitive.Title className="sr-only">
            {title}
          </DialogPrimitive.Title>
          {children}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}

export function DrawerDialogClose({
  children,
  className = "",
  ariaLabel = "Close drawer",
}: DrawerDialogCloseProps) {
  return (
    <DialogPrimitive.Close aria-label={ariaLabel} className={className}>
      {children}
    </DialogPrimitive.Close>
  );
}
